<template>
  <div class="d-inline-block text-center">
    <v-icon v-if="status.warning" color="red">warning</v-icon> <span>{{ status.label }}</span>
  </div>
</template>

<script>
  
  export default {
    name: 'ProcessorsStatusLabel',
    props: ['device'],
    computed: {
      status() {
        if (this.device.state) {
          if (this.device.state.gpu_throttling) {
            return {'label': 'GPU throttling', 'warning': true}
          } else if (
            this.device.product_name == 'edgecaster' && 
            (
              this.device.state.cpu_CPU1_throttling == true
              || this.device.state.cpu_CPU2_throttling == true
              || this.device.state.cpu_CPU3_throttling == true
              || this.device.state.cpu_CPU4_throttling == true
            )
          ) {
            return {'label': 'CPU throttling', 'warning': true}
          }
          return {'label': 'Good'}
        }
        return {'label': 'Unknown'}
      },
    },
    data() {
      return {
        showState: false,
      }
    }
  }
</script>